//export default class {}
module.exports = {
  proxy: "http://localhost:5000",
  assetsPath: "/pdf/viewer.html?file=pdfs/"
};

//proxy: "http://binuyapi"   - prod proxy: "http://localhost:5000"   - dev
